__turbopack_context__.v({
  "alloysLoremIpsum": "blog-grid-module__2iy1sq__alloysLoremIpsum",
  "beyondTheBasics": "blog-grid-module__2iy1sq__beyondTheBasics",
  "blogGrid": "blog-grid-module__2iy1sq__blogGrid",
  "blogGridContainer": "blog-grid-module__2iy1sq__blogGridContainer",
  "blogGridEyebrow": "blog-grid-module__2iy1sq__blogGridEyebrow",
  "blogGridHeading": "blog-grid-module__2iy1sq__blogGridHeading",
  "blogGridTitle": "blog-grid-module__2iy1sq__blogGridTitle",
  "button": "blog-grid-module__2iy1sq__button",
  "cards": "blog-grid-module__2iy1sq__cards",
  "caseStudyGrid": "blog-grid-module__2iy1sq__caseStudyGrid",
  "chevronLeftLarge": "blog-grid-module__2iy1sq__chevronLeftLarge",
  "chevronRightLarge": "blog-grid-module__2iy1sq__chevronRightLarge",
  "chevronRightSmall": "blog-grid-module__2iy1sq__chevronRightSmall",
  "container": "blog-grid-module__2iy1sq__container",
  "content": "blog-grid-module__2iy1sq__content",
  "contentGroup": "blog-grid-module__2iy1sq__contentGroup",
  "dieCastingResources": "blog-grid-module__2iy1sq__dieCastingResources",
  "dots": "blog-grid-module__2iy1sq__dots",
  "grid": "blog-grid-module__2iy1sq__grid",
  "navigation": "blog-grid-module__2iy1sq__navigation",
  "navigationWrapper": "blog-grid-module__2iy1sq__navigationWrapper",
  "nextButton": "blog-grid-module__2iy1sq__nextButton",
  "overviewGrid": "blog-grid-module__2iy1sq__overviewGrid",
  "pagination": "blog-grid-module__2iy1sq__pagination",
  "paginationButton": "blog-grid-module__2iy1sq__paginationButton",
  "paginationButton1": "blog-grid-module__2iy1sq__paginationButton1",
  "paginationDotIcon": "blog-grid-module__2iy1sq__paginationDotIcon",
  "paginationDotIcon1": "blog-grid-module__2iy1sq__paginationDotIcon1",
  "paginationDotIcon2": "blog-grid-module__2iy1sq__paginationDotIcon2",
  "paginationDotIcon3": "blog-grid-module__2iy1sq__paginationDotIcon3",
  "paginationWrapper": "blog-grid-module__2iy1sq__paginationWrapper",
  "prevButton": "blog-grid-module__2iy1sq__prevButton",
  "resourceCarouselTitle": "blog-grid-module__2iy1sq__resourceCarouselTitle",
  "resourceGrid": "blog-grid-module__2iy1sq__resourceGrid",
  "resourceGridContainer": "blog-grid-module__2iy1sq__resourceGridContainer",
  "resourceGridTitle": "blog-grid-module__2iy1sq__resourceGridTitle",
  "sentencesAboutCompany": "blog-grid-module__2iy1sq__sentencesAboutCompany",
  "slide": "blog-grid-module__2iy1sq__slide",
  "title": "blog-grid-module__2iy1sq__title",
  "viewAll": "blog-grid-module__2iy1sq__viewAll",
});
